export default (router, store) => {
    router.beforeEach(function (to, from, next) {
        if (store) {
            next()
        }
        next()
    })
    router.afterEach(function (to) {
        if (!to.meta) {
            to.meta = {}
        }
    })
}